import React, {FC, memo, useLayoutEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions} from "../../store/sliceApp";
import {actions as modal} from "../../store/sliceModal";
import {actions as websocket} from "../../store/sliceWebsocket";
import {PageHomeContainer} from "./PageHomeStyle";
import Stomp from "../../component/stomp/Stomp";
import {fetchUser} from "../../fetch/AuthRequest";
import {IUser} from "../../store/sliceUser";
import Page from "./Page";

const PageHome: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [access, setAccess] = useState(false);

    useLayoutEffect(() => {
        dispatch(actions.setHome())
        fetchUser().then((response) => {
            const user: IUser = response.data
            if (!user.roles?.includes("USER_SMART_HOME_ROLE")) {
                setAccess(false)
                dispatch(modal.showError("Доступ Запрещен"))
            } else {
                setAccess(true)
            }
        })
    }, [dispatch])

    const init = () => {
        dispatch(websocket.send({body: "", topic: "/app/kettle.status"}))
        dispatch(websocket.send({body: "", topic: "/app/receiver.status"}))
        dispatch(websocket.send({body: "", topic: "/app/temperature.status"}))
        dispatch(websocket.send({
            body: JSON.stringify({index: 0, input: "net_radio"}),
            topic: "/app/receiver.netRadio.info"
        }))
        dispatch(websocket.send({
            body: JSON.stringify({index: 0, input: "usb"}),
            topic: "/app/receiver.usb.info"
        }))
    }
    return (
        <PageHomeContainer>
            <Stomp init={init}>
                <div>
                    {access && <Page/>}
                </div>
            </Stomp>
        </PageHomeContainer>

    )
}


export default memo(PageHome)

